import React from 'react';
import Chart from "react-apexcharts";

const Pie = () => {
    var options = {
        labels: ['Apple', 'Mango', 'Orange', 'Watermelon'],
        series: [44, 55, 41, 17],
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: '62%'
                }
            }
        }
    }


    return (
        <div className='bg-white rounded-md drop-shadow-sm'>
            <h2 className='card-title '>Hotel Survay</h2>
            <Chart
                options={options}
                series={options.series}
                type="donut"
                width="100%"
            />
        </div>
    )
}


export default Pie;